const host = 'https://microsites-fs2.appspot.com/api/v1/';
//const host = 'https://shane7-dot-microsites-fs2.appspot.com/api/v1/';

export const RPCBackend = host + 'block-rpc';
export const BlockBackend = host + 'block';
